/*
 * @Descripttion: 工具函数
 */
let tools = {}

export default {
  install(Vue) {
    Vue.prototype.$tools = tools
  },
}
